// Pizza Toppings card game data - ranked by popularity
export const PIZZA_TOPPINGS_CARDS = [
  { id: 1, name: "Pepperoni", rank: 1, image: "/images/pizzaToppings/pizzaToppings_1.jpg" },
  { id: 2, name: "Sausage", rank: 2, image: "/images/pizzaToppings/pizzaToppings_2.jpg" },
  { id: 3, name: "Mushrooms", rank: 3, image: "/images/pizzaToppings/pizzaToppings_3.jpg" },
  { id: 4, name: "Extra Cheese", rank: 4, image: "/images/pizzaToppings/pizzaToppings_4.jpg" },
  { id: 5, name: "Onions", rank: 5, image: "/images/pizzaToppings/pizzaToppings_5.jpg" },
  { id: 6, name: "Black Olives", rank: 6, image: "/images/pizzaToppings/pizzaToppings_6.jpg" },
  { id: 7, name: "Green Peppers", rank: 7, image: "/images/pizzaToppings/pizzaToppings_7.jpg" },
  { id: 8, name: "Bacon", rank: 8, image: "/images/pizzaToppings/pizzaToppings_8.jpg" },
  { id: 9, name: "Ham", rank: 9, image: "/images/pizzaToppings/pizzaToppings_9.jpg" },
  { id: 10, name: "Pineapple", rank: 10, image: "/images/pizzaToppings/pizzaToppings_10.jpg" },
  { id: 11, name: "Jalapeños", rank: 11, image: "/images/pizzaToppings/pizzaToppings_11.jpg" },
  { id: 12, name: "Tomatoes", rank: 12, image: "/images/pizzaToppings/pizzaToppings_12.jpg" },
  { id: 13, name: "Spinach", rank: 13, image: "/images/pizzaToppings/pizzaToppings_13.jpg" },
  { id: 14, name: "Chicken", rank: 14, image: "/images/pizzaToppings/pizzaToppings_14.jpg" },
  { id: 15, name: "Anchovies", rank: 15, image: "/images/pizzaToppings/pizzaToppings_15.jpg" },
  { id: 16, name: "Red Onions", rank: 16, image: "/images/pizzaToppings/pizzaToppings_16.jpg" },
  { id: 17, name: "Banana Peppers", rank: 17, image: "/images/pizzaToppings/pizzaToppings_17.jpg" },
  { id: 18, name: "Garlic", rank: 18, image: "/images/pizzaToppings/pizzaToppings_18.jpg" },
  { id: 19, name: "Basil", rank: 19, image: "/images/pizzaToppings/pizzaToppings_19.jpg" },
  { id: 20, name: "Ricotta", rank: 20, image: "/images/pizzaToppings/pizzaToppings_20.jpg" }
];
